import classnames from "classnames";
import { Slot } from "../Slot/Slot";
import styles from "./TripleSticky.module.scss";
import { LayoutProps } from "../layoutMap";

const cx = classnames.bind(styles);

export const slotNameMap = {
  HEADER: "header",
  BANNER: "banner",
  TOP: "top",
  DETAILS_MEDIA_IMG: "details-media-img",
  DETAILS_MEDIA_BODY: "details-media-body",
  DETAILS_HEAD: "details-head",
  DETAILS_BODY: "details-body",
  ACCESSORY: "accessory",
  ACCESSORY_FOOT: "accessory-foot",
  ACCESSORY_TRIPLE_STICKY: "accessory-triple-sticky",
  BOTTOM: "bottom",
  FOOTER: "footer",
} as const;

export function TripleSticky(props: LayoutProps) {
  const layoutTestId = props.pageConfig?.layoutProps?.testId ?? "layout";
  const isOOSLayout = props.pageConfig?.layoutProps?.isOOSLayout === true;
  const typographyVariant =
    props.flags?.useNewTypography?.value === true
      ? "body-m-to-body-s"
      : "control";

  return (
    <div
      className={styles.page}
      data-layout="Default"
      data-typography-variant={typographyVariant}
    >
      <Slot {...props} name={slotNameMap["HEADER"]} sizes="100vw" />
      <main data-testid={layoutTestId} className={styles.main} id="main">
        <Slot
          {...props}
          name={slotNameMap["BANNER"]}
          className={styles.banner}
          sizes="(min-width: 1248px) 1200px, (min-width: 768px) calc(100vw - 48px), (min-width: 568px) calc(100vw - 32px), 100vw"
        />
        <Slot
          {...props}
          name={slotNameMap["TOP"]}
          className={styles.top}
          sizes="(min-width: 1248px) 1200px, (min-width: 768px) calc(100vw - 48px), (min-width: 568px) calc(100vw - 32px), 100vw"
        />
        <div className={styles.container}>
          <div data-testid="column-container" className={cx(styles.grid)}>
            <div className={classnames(styles.gridCol, styles.sticky)}>
              <div className={styles.detailsMediaWrapper}>
                <Slot
                  name={slotNameMap["DETAILS_MEDIA_IMG"]}
                  className={styles.detailsMediaImg}
                  {...props}
                  sizes="(min-width: 1248px) 400px, (min-width: 1024px) calc((100vw - 48px) * 0.4 - 80px), (min-width: 768px) calc((100vw - 48px) * 0.5 - 48px), (min-width: 568px) calc(100vw - 64px), calc(100vw - 32px)"
                />
                <Slot
                  name={slotNameMap["DETAILS_MEDIA_BODY"]}
                  className={styles.detailsMediaBody}
                  {...props}
                  sizes="(min-width: 1248px) 400px, (min-width: 1024px) calc((100vw - 48px) * 0.4 - 80px), (min-width: 768px) calc((100vw - 48px) * 0.5 - 48px), (min-width: 568px) calc(100vw - 64px), calc(100vw - 32px)"
                />
              </div>
              <Slot
                {...props}
                name={slotNameMap["DETAILS_HEAD"]}
                className={styles.detailsHead}
                sizes="(min-width: 1248px) 400px, (min-width: 1024px) calc((100vw - 48px) * 0.5 - 80px), (min-width: 768px) calc((100vw - 48px) * 0.5 - 48px), (min-width: 568px) calc(100vw - 64px), calc(100vw - 32px)"
              />
              <Slot
                {...props}
                name={slotNameMap["DETAILS_BODY"]}
                className={styles.detailsMain}
                sizes="(min-width: 1248px) 400px, (min-width: 1024px) calc((100vw - 48px) * 0.5 - 80px), (min-width: 768px) calc((100vw - 48px) * 0.5 - 48px), (min-width: 568px) calc(100vw - 64px), calc(100vw - 32px)"
              />
            </div>
            <div className={classnames(styles.gridCol, styles.sticky)}>
              <Slot
                {...props}
                name={slotNameMap["ACCESSORY"]}
                className={isOOSLayout ? styles.accessoryOOS : styles.accessory}
                sizes="(min-width: 1248px) 592px, (min-width: 1024px) calc((100vw - 48px) * 0.5), (min-width: 768px) calc((100vw - 48px) * 0.5), (min-width: 568px) calc(100vw - 32px), 100vw"
              />
              <Slot
                {...props}
                name={slotNameMap["ACCESSORY_FOOT"]}
                className={styles.accessoryFoot}
                sizes="(min-width: 1248px) 592px, (min-width: 1024px) calc((100vw - 48px) * 0.5), (min-width: 768px) calc((100vw - 48px) * 0.5), (min-width: 568px) calc(100vw - 32px), 100vw"
              />
            </div>
            <div className={classnames(styles.gridCol, styles.sticky)}>
              <Slot
                {...props}
                name={slotNameMap["ACCESSORY_TRIPLE_STICKY"]}
                className={isOOSLayout ? styles.accessoryOOS : styles.accessory}
                sizes="(min-width: 1248px) 592px, (min-width: 1024px) calc((100vw - 48px) * 0.5), (min-width: 768px) calc((100vw - 48px) * 0.5), (min-width: 568px) calc(100vw - 32px), 100vw"
              />
            </div>
          </div>
        </div>
        <Slot
          {...props}
          name={slotNameMap["BOTTOM"]}
          className={styles.bottom}
          sizes="(min-width: 1248px) 1200px, (min-width: 768px) calc(100vw - 48px), (min-width: 568px) calc(100vw - 32px), 100vw"
        />
      </main>
      <Slot {...props} name={slotNameMap["FOOTER"]} sizes="100vw" />
    </div>
  );
}
